import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { useNavigate, Link } from "react-router-dom";
import { requestPasswordReset } from "../../api";
import AuthPageBackground from "../Shared/AuthPageBackground/AuthPageBackground";
import "../LogIn/LogIn.css";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// KHAN-86: pantalla de "¿Olvidó su contraseña?" enlazada desde LogIn.
function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (!EMAIL_PATTERN.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    // Product decision: the backend now reports whether the email is
    // registered so we can tell the user directly, instead of always
    // showing the same "check your email" message regardless of outcome.
    requestPasswordReset(email)
      .then((res) => {
        if (res.data?.exists) {
          setSubmitted(true);
        } else {
          setError("We couldn't find an account with that email address.");
        }
      })
      .catch((e) => {
        const data = e.response?.data;
        setError(
          data?.error || "Something went wrong sending the reset code. Please try again."
        );
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <AuthPageBackground>
      <div className="login-form">
        <div className="login-form-body">
          {submitted ? (
            <div className="login-form-content">
              <h1 className="login-form-title">Check your email</h1>
              <h5 className="login-form-subtitle">
                We've sent a password reset code to {email}.
              </h5>
              <Link to="/reset-password" className="login-form-button-filled" style={{ textAlign: "center", textDecoration: "none", display: "block", lineHeight: "40px" }}>
                I have my reset code
              </Link>
            </div>
          ) : (
            <Form onSubmit={handleSubmit} className="login-form-content">
              <h1 className="login-form-title">Forgot your password?</h1>
              <h5 className="login-form-subtitle">
                Enter your email and we'll send you a code to reset it.
              </h5>
              <div className="login-form-inputs">
                <Form.Group className="form-group">
                  <Form.Label className="font-size">
                    <FontAwesomeIcon className="login-icons" icon={faEnvelope} />
                    Email
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="login-form-control-lg"
                    placeholder="example@mep.co.cr"
                    required
                  />
                </Form.Group>
                {error && <div className="font-error">{error}</div>}
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className={email ? "login-form-button-filled" : "login-form-button-empty"}
                >
                  Send reset code
                </Button>
              </div>
            </Form>
          )}
          <div style={{ marginTop: 16, textAlign: "center" }}>
            <span
              className="font-size"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => navigate("/")}
            >
              Back to Log In
            </span>
          </div>
        </div>
      </div>
    </AuthPageBackground>
  );
}

export default ForgotPassword;
